import { Component, inject, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from '../../services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../../user/login/login.component';

@Component({
  selector: 'app-site-toolbar-buttons',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIcon,
  ],
  templateUrl: './site-toolbar-buttons.component.html',
  styleUrl: './site-toolbar-buttons.component.scss',
})
export class SiteToolbarButtonsComponent {
  @Output() toggleMobileMenu = new EventEmitter<void>();
  
  userService = inject(UserService);
  readonly dialog = inject(MatDialog);

  login() {
    const dialogRef = this.dialog.open(LoginComponent, {
      panelClass: 'login-dialog',
      width: '400px',
    });
  }

  onToggleMobileMenu() {
    this.toggleMobileMenu.emit();
  }
}
